import * as React from 'react';
import { SVGProps } from 'react';

const IconDocFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10.828a2 2 0 0 0-.586-1.414l-6.828-6.828A2 2 0 0 0 15.172 2H6Zm16 10-8-8v6a2 2 0 0 0 2 2h6Zm-8 8H7v3h7v-3Zm-7-5h14v3H7v-3Z"
    />
  </svg>
);
export default IconDocFilledSizeL;
